const DPRS = [1]; // dpr = device pixel ratios. When we'll want to add more options, add here [1, 2, 3]

export const createSrcSet = uri => {
  const imageType = getImageType(uri);
  const srcSet = DPRS.map(dpr => {
    return `${uri} ${dpr}x`;
  }).join(', ');
  return {
    srcSet,
    imageType
  };
};
const getImageType = originalUrl => {
  const match = originalUrl.match(/[^.]+\w*$/) || ['jpeg'];
  return match[0];
};
//# sourceMappingURL=mediaUtils.js.map